import React from 'react';

import { classes } from './MissedIcon.st.css';
import { FCWithChildren } from '@wix/challenges-web-library';

export const MissedIcon: FCWithChildren = () => {
  return (
    <div className={classes.root}>
      <span className={classes.rootCircle}></span>
    </div>
  );
};
